import { IconContent } from '@icons';

export const chain: IconContent = {
    sm: '<path d="M12.24 3.76a2 2 0 0 1 0 2.83L10.83 8l.7.7 1.42-1.4a3 3 0 1 0-4.24-4.25L7.29 4.46l.71.71 1.41-1.41a2 2 0 0 1 2.83 0Zm-8.48 8.48a2 2 0 0 0 2.83 0L8 10.83l.7.7-1.4 1.42a3 3 0 1 1-4.25-4.24l1.41-1.42.71.71-1.41 1.41a2 2 0 0 0 0 2.83Zm6-6.71L5.54 9.77l.7.7 4.24-4.24-.7-.7Z" />',
};
